import { createStyles, Theme } from '@material-ui/core'

export const useSettlementKpiBlocksCardStyles = (theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: theme.spacing(2)
    },
    container: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      rowGap: theme.spacing(2)
    },
    // Título y datos de la ejecución en la misma fila, uno al lado del otro
    header: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'flex-start',
      columnGap: theme.spacing(4),
      rowGap: theme.spacing(2)
    },
    detailLabel: {
      textTransform: 'uppercase',
      letterSpacing: '0.06em'
    },
    blocks: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'stretch',
      columnGap: theme.spacing(2),
      rowGap: theme.spacing(2),
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column'
      }
    }
  })
